import axios from '../../functions/axios';
import { useState, useEffect } from 'react';
import editButton from '../../assets/images/editButton.png';
import { useNavigate, Link } from 'react-router-dom';
import style from './CarriagePaletteClients.module.css';
import { useAuthContext } from '../../hooks/useAuthContext';
import { Grid } from '@mui/material';

function ClientsList() {
  const [apiData, setApiData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { user } = useAuthContext();

  const getClientsData = async () => {
    if (!user) return null;
    try {
      const { data: response } = await axios.get('/client', {
        params: {
          paletts: true,
        }
      });
      setApiData(response);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleEditClient = (client) => {
    navigate('/editClient', { state: { client, from: '/carriagePaletteClientsList' } });
  };

  useEffect(() => {
    getClientsData();
  }, [user]);

  const handleFilterClients = (searchQuery) => setSearchQuery(searchQuery.trim().toLowerCase());

  return (
    <>
      <div className={style.menu}>
        <div className={style.filter}>
          <p>Wyszukaj Klienta:</p>
          <input type='search' className='form-control' placeholder='Nazwa kontrahenta' onChange={(e) => handleFilterClients(e.target.value)}></input>
        </div>
        <button className='btn btn-default' onClick={navigate.bind(null, '/addClient', { state: { from: '/carriagePaletteClientsList' } })}>Dodaj Klienta</button>
      </div>
      <Grid container className={style.container}>
        {
        apiData
          .filter(client => !client.name)
          .filter((client) => {
            if (searchQuery === '')
              return true;
            return client.companyName.toLowerCase().includes(searchQuery);
          })
          .sort((...args) => {
            const [a, b] = args.map((client) => client.companyName);
            return a.localeCompare(b, 'pl', { sensitivity: 'base' });
          })
          .map((client, index) => (
            
            <Grid sx={6} item className={style.client} key={index}>
              <div className={style.company}>
              {/* <p className={style.clientName}>{client.companyName}</p> */}
              {/* <p className={style.clientPhone}>{client.phoneNumber}</p> */}
              <Link to='/carriagePaletteList' state={{ client }}>{client.companyName}</Link>
              </div>
              <div className={style.eur}>
                <p>EURO: {client.paletteBallanceE ?? 0} | DD: {client.paletteBallanceDD ?? 0}</p>
              </div>
              <img className={style.editButton} src={editButton} onClick={handleEditClient.bind(null, client)} />
            </Grid>
          ))}
      </Grid>
    </>
  );
}

export default ClientsList;